module.exports = function() {
  return new Worker(__webpack_public_path__ + "cea907623ef3125a6b28.worker.js");
};